// Dexie liveQuery → a Svelte-readable store, so screens re-render when the
// database changes — the web counterpart of the reference client's watch queries.

import { liveQuery } from 'dexie';
import { readable, type Readable } from 'svelte/store';

export function live<T>(query: () => Promise<T> | T, initial: T): Readable<T> {
  return readable(initial, (set) => {
    const subscription = liveQuery(query).subscribe({
      next: (value) => set(value),
      error: (error: unknown) => console.error('[live]', error),
    });
    return () => subscription.unsubscribe();
  });
}
